module.exports = __webpack_public_path__ + "img/about-辅导项目-中级职称（药学）类.0a1f0e36.jpg";